<template>
  <div class="main welcome2" @click="callMe">
    <div class="kupon-gosok-container type3">
    </div>
  </div>
</template>

<script>
import { event } from 'vue-gtag'
import { useHead } from '@vueuse/head'

export default {
  name: 'Welcome2Page',
  setup() {
    const css = [
      'css/scratch.css',
    ];

    const cssLink = css.map(src => ({
      rel: 'stylesheet',
      href: `${process.env.BASE_URL}${src}`,
    }))

    useHead({
      link: [
        ...cssLink
      ]
    })
  },
  methods: {
    callMe() {
      event('Success - Call UMB - KJ - Welcome2', {})
      setTimeout(function () {
        window.open("tel:*500*00%23");
      }, 500);
    },
  }
}

</script>
